import React, { useEffect, useRef, useState } from "react";
import { IMG } from "../../../../assets";
import "./Hero.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "./Doctors.css";

const array = [
  {
    id: 1,
    title: "Only High Quality Service Provider",
    img: IMG.B4,
  },
  {
    id: 2,
    title: "Only High Quality Service Provider",
    img: IMG.B1,
  },
  {
    id: 3,
    title: "Only High Quality Service Provider",
    img: IMG.B2,
  },
  {
    id: 4,
    title: "Only High Quality Service Provider",
    img: IMG.B3,
  },
];

export default function Hero() {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  // Scroll to the Contact section
  const scrollToContact = () => {
    const contactSection = document.getElementById("contact");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="relative bg-seconday md:h-screen h-[535px] flex flex-col items-center pb-[50px] sm:pb-[270px] pt-[330px] px-5 font-poppins tracking-wider">
      {/* Main Content - Positioned relative */}
      <div className="z-99 max-w-screen-2xl w-full h-auto">
        <div className="flex items-center w-auto text-white text-2xl sm:text-5xl md:text-6xl font-bold mt-[8%] md:mt-0">
          <p
        
          >
            Dental Excellence,
          </p>
         
        </div>
        <p
         
          className="w-full text-white text-2xl sm:text-5xl md:text-6xl font-bold md:py-5 pt-2 pb-4"
        >
          Personalized for you.
        </p>
        <button
          className="button glow-on-hover bg-primary md:px-8 px-4 py-2 text-secondry font-bold rounded-full"
          onClick={scrollToContact}
        >
          BOOK APPOINTMENT
        </button>
      </div>

      {/* Swiper Positioned Absolutely Below */}
      <div className="absolute inset-0 z-10 ">
        <Swiper
          slidesPerView={1}
          pagination={{ clickable: true, el: ".custom-pagination" }}
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
          }}
          centeredSlides={true}
          followFinger={true}
          grabCursor={false}
          loop={true}
          allowTouchMove={true}
          mousewheel={false}
          keyboard={{ enabled: false }}
          speed={900}
          modules={[Autoplay, Pagination]}
          className="mySwiper"
        >
          {/* Add custom pagination container here */}
          {array.map((data) => (
            <SwiperSlide key={data.id}>
              <div className="md:h-screen h-[535px]">
                <img
                  src={data.img}
                  alt={data.title}
                  className="h-full w-full object-cover"
                />
              </div>
            </SwiperSlide>
          ))}
          <div className="custom-pagination"></div>
        </Swiper>
      </div>
    </div>
  );
}
